import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-blue-950 px-4 pb-6 pt-5 text-center md:px-10 md:pb-7 md:pt-6" data-id="element-99" data-mp="28u4ncn43lelf">
      <p className="text-[13px] font-extrabold uppercase tracking-[0.08em] text-teal-300 md:text-[15px]" data-id="element-100" data-mp="28vza86yxjgs5">
        Pediatric OT Complete Therapy System™
      </p>
      <h1 className="mt-1.5 text-[24px] font-extrabold uppercase leading-[1.08] tracking-[-0.3px] text-white md:text-[34px]" data-id="element-101" data-mp="30ksqu5t8uw29">
        The complete visual intervention system for{' '}
        <span className="text-teal-300" data-id="element-102" data-mp="2rryxj4gypw5e">pediatric occupational therapists</span>
      </h1>
      <p className="mx-auto mt-3 max-w-[580px] text-[14px] leading-[1.45] text-white md:text-[16px]" data-id="element-103" data-mp="3fibfl85x999p">
        Fine motor skills, handwriting, bilateral coordination, sensory-informed participation, self-care, and school
        skills — all organized into one practical professional collection.
      </p>
      <p className="mx-auto mt-2 max-w-[580px] text-[13px] leading-[1.45] text-blue-200 md:text-[15px]" data-id="element-104" data-mp="2beyd8llffw1s">
        240 visual interventions, 40 complete therapy sessions, and 160 additional resources — each with functional
        goals, materials, clear steps, adaptations, and observable outcomes.
      </p>
      <p className="mx-auto mt-2.5 max-w-[560px] text-[13px] font-extrabold uppercase leading-tight text-amber-400 md:text-[15px]" data-id="element-105" data-mp="2z26jb5qoj94v">
        Less searching. More structured pediatric OT resources.
      </p>

      <div className="mx-auto mt-3 max-w-[340px]" data-id="element-106" data-mp="383nwaf8siupc">
        <ProductImage data-id="element-107" data-mp="335coea222u9r" />
      </div>

      <p className="mt-2 text-[13px] font-extrabold uppercase leading-tight text-teal-300 md:text-[15px]" data-id="element-108" data-mp="336earaoiv36s">
        6 Professional Volumes + 5 FREE Professional Bonuses
      </p>
      <p className="mt-0.5 text-[12px] font-bold uppercase text-blue-200 md:text-[13px]" data-id="element-109" data-mp="18rv8983zczor">
        11 Digital Resources | 440 Pages
      </p>

      <div className="mt-3.5" data-id="element-110" data-mp="38v5v95rhrys2">
        <CtaButton mode="scroll" subtext="Practical pediatric OT interventions you can adapt to each client" data-id="element-111" data-mp="3dsehbhfrgmyl">
          Yes! I want the complete system!
        </CtaButton>
      </div>
      <p className="mx-auto mt-3 max-w-[440px] text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-112" data-mp="3itveb1v4jp9w">
        Instant digital access
        {guaranteeEnabled && <>
            {' • '}
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-300" aria-hidden data-id="element-113" data-mp="lmf1nho9l6w" />
            7-day money-back guarantee
          </>}
      </p>
    </header>;
}